import _ from 'lodash'
import axios from 'axios'
import Cookies from 'js-cookie'
import utils from './utils'

const transformRequest = data => {
    if (utils.isFormData(data) ||
        utils.isArrayBuffer(data) ||
        utils.isBuffer(data) ||
        utils.isStream(data) ||
        utils.isFile(data) ||
        utils.isBlob(data) ||
        utils.isArrayBufferView(data) ||
        utils.isURLSearchParams(data)
    ) {
        return data
    }
    if (utils.isObject(data)) {
        for (var pkey in data) {
            if (data[pkey] === null || typeof (data[pkey]) === 'undefined') {
                delete data[pkey]
            }
        }
        data = utils.params(data)
        return data
    }
    return data
}

axios.defaults.transformRequest.unshift(transformRequest)

const basePath = () => {
    let basePath = process.env.VUE_APP_SERVER_PATH || location.protocol + '//' + location.host
    if (basePath.charAt(basePath.length - 1) === '/') {
        basePath = basePath.substring(0, basePath.length - 1)
    }
    return basePath
}

const checkUrl = (url) => {
    if (url) {
        if (url.indexOf('/') === 0) {
            url = url.substring(1)
        }
        if (url.indexOf('http') !== 0) {
            url = basePath() + '/' + url
        }
    } else {
        url = basePath()
    }
    return url
}

const instance = axios.create({
    baseURL: basePath()
})

instance.basePath = function () {
    return basePath()
}

instance.url = function(url, options) {
    if (!url) {
        return
    }
    url = checkUrl(url)
    if (_.isEmpty(options)) {
        return url
    }
    let token = null
    if (Cookies.get('user_token')) {
        token = Cookies.get('user_token')
    } else if (Cookies.get('client_token')) {
        token = Cookies.get('client_token')
    } else {
        token = null
    }
    if (token) {
        if (!options['access_token']) {
            options['access_token'] = token
        }
    }
    if (!_.isEmpty(options)) {
        let data = utils.params(options)
        url += '?' + data
    }
    return url
}

instance.download = function (url, options) {
    if (!url) {
        return
    }
    if (url.indexOf('http') !== 0) {
        url = checkUrl(url)
    }
    let token = null
    if (Cookies.get('user_token')) {
        token = Cookies.get('user_token')
    } else if (Cookies.get('client_token')) {
        token = Cookies.get('client_token')
    } else {
        token = null
    }
    if (_.isEmpty(options)) {
        options = {}
    }
    if (token) {
        if (!options['access_token']) {
            options['access_token'] = token
        }
    }
    if (!_.isEmpty(options)) {
        let data = utils.params(options)
        url += '?' + data
    }
    // top.location.href = url
    window.open(url)
}

instance.open = function (url, options) {
    if (!url) {
        return
    }
    if (url.indexOf('http') !== 0) {
        url = checkUrl(url)
    }
    let token = null
    if (Cookies.get('user_token')) {
        token = Cookies.get('user_token')
    } else if (Cookies.get('client_token')) {
        token = Cookies.get('client_token')
    } else {
        token = null
    }
    if (_.isEmpty(options)) {
        options = {}
    }
    if (token) {
        if (!options['access_token']) {
            options['access_token'] = token
        }
    }
    if (!_.isEmpty(options)) {
        let data = utils.params(options)
        url += '?' + data
    }
    // top.location.href = url
    window.open(url)
}

// request interceptor
instance.interceptors.request.use(config => {
    let token = null
    if (config.url.indexOf('/oauth/token') >= 0) {
        token = 'Basic ' + btoa(process.env['VUE_APP_CLIENT'])
    } else if (Cookies.get('user_token')) {
        token = 'Bearer ' + Cookies.get('user_token')
    } else if (Cookies.get('client_token')) {
        token = 'Bearer ' + Cookies.get('client_token')
    } else {
        token = null
    }
    if (token) {
        config.headers['Authorization'] = token
    } else {
        location.href = process.env['VUE_APP_LOGIN_URL']
    }
    if (config.url.indexOf('http') !== 0) {
        config.url = checkUrl(config.url)
    }
    return config
}, error => {
    Promise.reject(error)
})

// respone interceptor
instance.interceptors.response.use(response => {
    return response.data
}, error => {
    error.response.body = error.response.data
    if (error.response.config.url.indexOf('/oauth/token') >= 0) {
        return Promise.reject(error.response.data)
    }
    let response = error.response
    // let config = response.config
    // if (response['status'] === 401 && response.data && response.data.error === 'invalid_token') {
    //   store.dispatch('refreshToken').then(() => {
    //     instance(config)
    //   }, () => {
    //     location.href = process.env['PATH_LOGIN']
    //     return Promise.reject(response.data)
    //   })
    // }
    return Promise.reject(response.data)
})

export default instance
